import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchParam } from '../../../core/routing/param';
import { useSearchParam } from '../../../core/routing/hooks/use-search-param';
import { FormType } from '../../backend/openapi/api-types';
import { AuthenticatedForm } from './authenticated-form';

export const InquiryAboutArticle: React.FC = () => {
  const { t } = useTranslation();
  const params = useSearchParam([SearchParam.articleId, SearchParam.weightKg, SearchParam.container]);

  return (
    <AuthenticatedForm
      documentTitle={t('form.inquiryAboutArticle.documentTitle')}
      formType={FormType.inquiryAboutArticle}
      queryParam={params}
    />
  );
};
